/**
 * 
 * @param base the existing route section
 * @param append the route section to be appended
 * @returns safely joined route without additional forward slashes (note: doesn't account for query params)
 */
export const joinPath = (base: string, append: string) => {
  return `${base.replace(/\/+$/, '')}/${append.replace(/^\/+/, '')}`;
};